import Closed from "../component/app/closed";
import { useState } from "react";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import { UnControlled as CodeMirror } from "react-codemirror2";
require("codemirror/mode/javascript/javascript");

export default function Sublime(props) {
  const [container] = useState(
    "bg-white w-full h-92vh transition-all duration-500 transform "
  );
  return (
    <div
      className={
        props.open ? container + "scale-100" : container + "scale-0 hidden"
      }
    >
      <Closed name="Sublime Text 3" />
      <div className="flex flex-wrap justify-center h-full">
        <div className="w-1/5 hidden sm:block border-r h-full p-6">
          <h5>Folders</h5>
          <div className="w-full mt-4">
            <div className="flex border-b border-gray-200 hover:bg-gray-100 cursor-pointer">
              app.js
            </div>
            <div className="flex border-b border-gray-200 hover:bg-gray-100 cursor-pointer">
              package.json
            </div>
          </div>
        </div>
        <div className="w-4/5 h-full">
          <div className="flex justify-center space-x-3 w-full px-2">
            <div className="text-sm p-2 hover:bg-gray-200 cursor-pointer">
              Menu
            </div>
            <div className="text-sm p-2 hover:bg-gray-200 cursor-pointer">
              Find
            </div>
            <div className="text-sm p-2 hover:bg-gray-200 cursor-pointer">
              Options
            </div>
            <div className="text-sm p-2 hover:bg-gray-200 cursor-pointer">
              Developer
            </div>
            <div className="text-sm p-2 hover:bg-gray-200 cursor-pointer">
              About
            </div>
          </div>
          <CodeMirror
            value="console.log('Hello World')"
            options={{
              mode: "javascript",
              theme: "material",
              lineNumbers: true
            }}
            className="w-full"
            onChange={(editor, data, value) => {}}
          />
        </div>
      </div>
    </div>
  );
}
